export const REMINDER_TYPE = [
  // 展示类型: 1 不重复,2 每天,3 每周,4 每月,5 每年
  {
    id: 1,
    label: '不重复'
  },
  {
    id: 2,
    label: '每天'
  },
  {
    id: 3,
    label: '每周'
  },
  {
    id: 4,
    label: '每月'
  },
  {
    id: 5,
    label: '每年'
  }
]
